import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getLocalStorageItem } from "../Utils/Index";
function PublicAuth(props) {
  const location = useLocation();
  const isAuthenticated = () => {
    const user = getLocalStorageItem("access_token");
    return user;
  };

  const allowPublicPaths = ["/single-or-group", "/order-by-customer"];
  const isAllowedPublicPath = allowPublicPaths.includes(location.pathname);

  if (isAllowedPublicPath) {
    return <Outlet />;
  }

  return isAuthenticated() ? (
    <>
      {" "}
      <Navigate to="/Dashboard" />
    </>
  ) : (
    <Outlet />
  );
}
export default PublicAuth;
